import z from 'zod';

export const $bool = z.preprocess(val => {
  return val !== 'false' && val !== '0' && val !== 0 && Boolean(val);
}, z.boolean());
